"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.component("mktHistoryChart", {
  bindings: {
    references: "<",
    forward: "<",
    forwardNbAnnees: "<",
    spread: "<",
    chartConfig: "<",
    onPointClick: "<",
    onSetExtremes: "<"
  },
  template: require("./mktHistoryChart.html"),
  controller: function controller($scope, chartUtils, contextService, $numberFormat, fixingService, mktHistoryUtils, stringUtils, customIndexationService, mktChartUtils, $translate) {
    var getAxis = mktChartUtils.getAxis,
      getIndiceTypes = mktChartUtils.getIndiceTypes,
      getReferenceIndexType = mktChartUtils.getReferenceIndexType,
      getReferenceLabel = mktChartUtils.getReferenceLabel;
    var ctrl = this;
    var customIndexations = [];
    ctrl.$onInit = function () {
      customIndexationService.fetchIndexations().then(function (indexations) {
        customIndexations = indexations;
      });
    };
    ctrl.$onChanges = function (changes) {
      onInputChange();
    };
    function onInputChange() {
      if (ctrl.references.length > 0) {
        // todo NFR - il serait bien d'arreter le chargement en cours si il y en a déjà un avant de relancer l'update question de ne pas avoir de race
        updateChartData().then(function () {
          refreshChartConfig();
        });
      }
    }
    function isSpread() {
      return ctrl.references != null && ctrl.references.length === 2 && ctrl.spread === true;
    }
    function onChartSetExtremes(dateMin, dateMax) {
      if (ctrl.onSetExtremes) {
        ctrl.onSetExtremes(dateMin, dateMax);
      }
      updateChartData(dateMin, dateMax).then(function () {
        ctrl.chartConfig.series = generateChartSeries();
      });
    }

    /**
     * Updates the chart data for current references and options.
     *
     * @param dateDebut
     * @param dateFin
     * @return {*|Promise.<TResult>}
     */
    function updateChartData(dateDebut, dateFin) {
      if (isSpread()) {
        ctrl.loading = true;
        return fixingService.getSpreadHistory(ctrl.references[0], ctrl.references[1], {
          dateDebut: dateDebut,
          dateFin: dateFin,
          forward: ctrl.forward ? ctrl.forwardNbAnnees : 0
        }).then(function (data) {
          ctrl.chartData = data;
        }).finally(function () {
          ctrl.loading = false;
        });
      } else {
        ctrl.loading = true;
        return fixingService.getMultipleHistory(ctrl.references, {
          dateDebut: dateDebut,
          dateFin: dateFin,
          forward: ctrl.forward ? ctrl.forwardNbAnnees : 0
        }).then(function (indexHistories) {
          ctrl.chartData = indexHistories.histories;
        }).finally(function () {
          ctrl.loading = false;
        });
      }
    }

    /**
     * Refresh the chart config according to current indexations and options and inject it to controller
     */
    function refreshChartConfig() {
      if (ctrl.references == null || ctrl.references.length === 0) {
        return;
      }
      var chartConfig = isSpread() ? getSpreadModeChartConfig() : getClassicModeChartConfig();
      chartConfig.series = generateChartSeries();
      ctrl.chartConfig = chartConfig;
    }
    function generateChartSeries() {
      var series = [];
      if (isSpread()) {
        series.push({
          id: "spread-" + mktHistoryUtils.getReferenceId(ctrl.references[0]) + "-" + mktHistoryUtils.getReferenceId(ctrl.references[1]),
          name: "Spread (" + getReferenceLabel(ctrl.references[0]) + " - " + getReferenceLabel(ctrl.references[1]) + ")",
          data: chartUtils.mapAndFilter(ctrl.chartData.fixings, "date", "valeur"),
          color: chartUtils.getGraphColor(0),
          indexType: getReferenceIndexType(ctrl.references[0])
        });
      } else {
        var indexTypes = getIndiceTypes(ctrl.references);
        _.each(ctrl.references, function (reference, i) {
          var referenceIndexType = getReferenceIndexType(reference);
          var axisIndex = _.indexOf(indexTypes, referenceIndexType);
          var data;
          if (ctrl.chartData[i] == null) {
            console.log("Pas de fixing pour " + getReferenceLabel(reference), i);
            data = [];
          } else {
            data = chartUtils.mapAndFilter(ctrl.chartData[i].fixings, "date", "valeur");
          }
          series.push({
            id: mktHistoryUtils.getReferenceId(reference),
            name: getReferenceLabel(reference),
            data: data,
            color: chartUtils.getGraphColor(i),
            yAxis: axisIndex,
            indexType: referenceIndexType
          });
        });
      }
      return series;
    }

    /**
     * Generates the chart config for the classic mode.
     */
    function getClassicModeChartConfig() {
      var chartConfig = getBaseChartConfig();
      var title, subtitle;
      var references = ctrl.references;
      var indexTypes = getIndiceTypes(references);
      var axises = _.map(indexTypes, getAxis);
      if (references.length === 1) {
        title = chartUtils.tooltipElement(getReferenceLabel(references[0]), {
          color: chartUtils.getGraphColor(0)
        });
        if (references[0].type === "CUSTOM_INDEXATION") {
          var indexation = _.find(customIndexations, {
            id: references[0].indexationId
          });
          if (indexation != null) {
            subtitle = indexation.expression;
          }
        }
      } else if (references.length === 2) {
        title = chartUtils.tooltipElement(getReferenceLabel(references[0]), {
          color: chartUtils.getGraphColor(0)
        }) + " et " + chartUtils.tooltipElement(getReferenceLabel(references[1]), {
          color: chartUtils.getGraphColor(1)
        });
      } else {
        title = null;
        chartConfig.options.legend = {
          enabled: true,
          align: 'right',
          verticalAlign: 'top',
          layout: "vertical",
          x: -10,
          y: 30,
          floating: true
        };
      }
      chartConfig.options.yAxis = axises;
      chartConfig.options.subtitle.text = subtitle;
      chartConfig.title.text = title;
      return chartConfig;
    }

    /**
     * Generates the chart config for the spread mode.
     */
    function getSpreadModeChartConfig() {
      var chartConfig = getBaseChartConfig();
      var firstReference = ctrl.references[0],
        secondReference = ctrl.references[1];
      var indexType = getReferenceIndexType(firstReference);
      var firstLabel = stringUtils.escapeHtml(getReferenceLabel(firstReference)),
        secondLabel = stringUtils.escapeHtml(getReferenceLabel(secondReference));
      var title = "Spread (" + firstLabel + " - " + secondLabel + ")";
      var yAxis = {
        title: {
          text: mktHistoryUtils.getIndexTypeAxisLabel(indexType),
          style: {
            color: chartUtils.getGraphColor(0)
          }
        },
        labels: {
          formatter: function formatter() {
            return indexType === "TAUX" ? $numberFormat.percentage(this.value, 2) : $numberFormat.number(this.value, 2);
          },
          style: {
            color: chartUtils.getGraphColor(0)
          }
        },
        plotLines: [{
          color: '#9C9C9C',
          width: 1,
          value: 0.0,
          zIndex: 5
        }, {
          color: '#FF00FF',
          width: 1,
          value: ctrl.chartData.avg,
          zIndex: 5,
          label: {
            text: $translate('marche.history.graphique.spreadMoyen'),
            align: 'right',
            x: -5
          }
        }]
      };
      chartConfig.title.text = title;
      chartConfig.options.yAxis = yAxis;
      return chartConfig;
    }

    /**
     * Returns the base config for both chart modes.
     */
    function getBaseChartConfig() {
      return {
        useHighStocks: true,
        title: {
          text: ''
        },
        series: [],
        options: {
          reset: _.uniqueId("chart-reset"),
          chart: {
            animation: false,
            zoomType: 'x',
            height: 400,
            borderColor: '#322f8f',
            events: {
              click: function click(e) {
                if (ctrl.onPointClick) {
                  var axisValue = e.xAxis[0].value;
                  var date = moment(axisValue).toDate();
                  $scope.$apply(function () {
                    ctrl.onPointClick(date);
                  });
                }
              }
            }
          },
          subtitle: {
            text: ''
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var format = moment(this.x).format("D MMM YYYY");
              var tooltip = "<b>" + format + "</b> <br/>";
              _.each(this.points, function (point) {
                var value = point.series.userOptions.indexType === "TAUX" ? $numberFormat.percentage(point.y, 2) : $numberFormat.number(point.y, 4);
                var serieLine = '<span style="color: ' + point.series.color + '; font-weight: bold;">' + point.series.name + '</span> : ' + value;
                tooltip += serieLine + "<br/>";
              });
              return tooltip;
            }
          },
          plotOptions: {
            series: {
              showInNavigator: true,
              pointInterval: 24 * 3600 * 1000,
              turboThreshold: 0,
              animation: false,
              events: {
                click: function click(e) {
                  if (ctrl.onPointClick) {
                    var pointDate = e.point.x;
                    var date = moment(pointDate).toDate();
                    $scope.$apply(function () {
                      ctrl.onPointClick(date);
                    });
                  }
                }
              }
            },
            line: {
              marker: {
                enabled: false
              }
            }
          },
          xAxis: {
            type: 'datetime',
            plotLines: ctrl.forward ? chartUtils.getDateMarchePlotLine(contextService) : null,
            minRange: 1000 * 3600 * 24 * 7,
            // one week
            maxZoom: 14 * 24 * 3600000,
            // fourteen days ,
            events: {
              afterSetExtremes: function afterSetExtremes(e) {
                if (e.trigger !== "updatedData" && e.trigger != null) {
                  var dateMin = moment(e.min).toDate(),
                    dateMax = moment(Math.round(e.max)).toDate();
                  $scope.$apply(function () {
                    onChartSetExtremes(dateMin, dateMax);
                  });
                }
              }
            }
          },
          yAxis: [],
          navigator: {
            enabled: true,
            adaptToUpdatedData: false
          },
          scrollbar: {
            liveRedraw: false
          },
          rangeSelector: {
            enabled: true
          }
        }
      };
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/historique/mktHistoryChart.js
// module id = 2848
// module chunks = 13